import { render, staticRenderFns } from "./RecoverPasswordForm.vue?vue&type=template&id=d8258098&scoped=true&"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=js&"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=js&"
import style0 from "./RecoverPasswordForm.vue?vue&type=style&index=0&id=d8258098&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8258098",
  null
  
)

export default component.exports